// @flow

import React from 'react'
import EjectIcon from 'react-icons/lib/fa/eject'
import { inject, observer } from 'mobx-react'
import { View, Button, Gutter, Spacer, Divider } from 'ui'
import { Toolbar } from 'app/components'
import LightIcon from 'react-icons/lib/md/lightbulb-outline'
import SwipeableViews from 'react-swipeable-views'
import MediaQuery from 'react-responsive'

import PlayListView from './play-list-view'
import AlbumListView from './album-list-view'
import PlayerView from './player-view'

import FilterGroup from './filter-group'
import OrderButtonGroup from './order-button-group'

import NowPlaying from './play-list-view/now-playing'
import PlaybackButtons from './player-view/playback-buttons'

@inject('appState')
@inject('playQueue')
@observer
class PlayerScreenMobile extends React.PureComponent {
  render() {
    const { appState, playQueue } = this.props

    return (
      <View flow="column" style={{ flex: 1 }}>
        <SwipeableViews index={1} style={{ display: 'flex', flex: 1, minWidth: 0 }} containerStyle={{ flex: 1, minWidth: 0 }} slideStyle={{ display: 'flex', minWidth: 0 }}>
          <View flow="column" style={{ flex: 1 }}>
            <Toolbar>
              <Button active={appState.themeName === 'dark'} style={{ width: 48, height: 34 }} onClick={() => appState.setThemeName(appState.themeName === 'dark' ? 'light' : 'dark')}><LightIcon size={18} /></Button>
              <Spacer />
              <Button style={{ width: 48, height: 34 }} onClick={() => appState.disconnect()}><EjectIcon size={18} /></Button>
            </Toolbar>
          </View>
          <View flow="column" style={{ flex: 1 }}>
            <Toolbar>
              <FilterGroup />
              <Gutter />
              <OrderButtonGroup />
            </Toolbar>
            <AlbumListView />
          </View>
          <PlayListView />
        </SwipeableViews>

        {playQueue.activeItem && <Divider />}
        {playQueue.activeItem && (
          <NowPlaying activeItem={playQueue.activeItem} style={{ alignItems: 'center' }}>
            <Gutter />
            <PlaybackButtons />
          </NowPlaying>
        )}
      </View>
    )
  }
}

@inject('appState')
@observer
class PlayerScreenDesktop extends React.PureComponent {
  render() {
    const { appState } = this.props

    return (
      <View flow="column" style={{ flex: 1 }}>
        <Toolbar>
          <View flow="row" style={{ flex: 1 }}>
            <FilterGroup />
            <Gutter />
            <OrderButtonGroup />
          </View>
          <Gutter size={16} />
          <View flow="row" style={{ flex: 1 }}>
            <PlayerView />
            <Gutter size={16} />
            <Button active={appState.themeName === 'dark'} style={{ width: 48, height: 34 }} onClick={() => appState.setThemeName(appState.themeName === 'dark' ? 'light' : 'dark')}><LightIcon size={18} /></Button>
            <Gutter size={4} />
            <Button style={{ width: 48, height: 34 }} onClick={() => appState.disconnect()}><EjectIcon size={18} /></Button>
          </View>
        </Toolbar>
        <Divider />
        <View flow="row" style={{ flex: 1 }}>
          <AlbumListView />
          <Divider />
          <PlayListView />
        </View>
      </View>
    )
  }
}

export default class PlayerScreen extends React.PureComponent {
  render() {
    return (
      <View style={{ flex: 1 }}>
        <MediaQuery query="(min-device-width: 1224px)" >
          <PlayerScreenDesktop />
        </MediaQuery>
        <MediaQuery query="(max-device-width: 1224px)">
          <PlayerScreenMobile />
        </MediaQuery>
      </View>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/views/player-view/index.jsx